import { call, put, takeLatest } from 'redux-saga/effects';

import { Role, RolesService } from '../../../entities/Roles';
import { BranchData } from '../../../entities/Branches/interfaces';
import { GetUserBranches } from '../../../entities/AADGroup/interfaces';
import { BranchService } from '../../../entities/Branches/service';
import { AADGroupService } from '../../../entities/AADGroup/services';
import { GET_BRANCHES_REQUEST, GET_ROLES_REQUEST, GET_USER_BRANCHES_REQUEST } from './constants';
import {
  getAllBranchError,
  getAllBranchSuccess,
  getRolesError,
  getRolesRequest,
  getRolesSuccess,
  getUserBranchesFailure,
  getUserBranchesRequest,
  getUserBranchesSuccess,
} from './actions';

function* getRolesSaga(action: ReturnType<typeof getRolesRequest>) {
  try {
    const { payload } = action;
    const roles: Role[] = yield call(RolesService.getRoles, payload);

    yield put(getRolesSuccess(roles));
  } catch (error: any) {
    yield put(getRolesError(error));
  }
}

function* getAllBrnachSaga() {
  try {
    const braches: BranchData[] = yield call(BranchService.getBranches);

    yield put(getAllBranchSuccess(braches));
  } catch (error: any) {
    yield put(getAllBranchError(error));
  }
}

function* getUserBranchesSaga(action: ReturnType<typeof getUserBranchesRequest>) {
  try {
    const { payload } = action;
    const aadGroups: GetUserBranches = yield call(AADGroupService.getUserBranches, payload);

    yield put(getUserBranchesSuccess(aadGroups));
  } catch (error) {
    yield put(getUserBranchesFailure(error));
  }
}

export function* logoutSagaWatcher() {
  yield takeLatest(GET_ROLES_REQUEST, getRolesSaga);
  yield takeLatest(GET_BRANCHES_REQUEST, getAllBrnachSaga);
  yield takeLatest(GET_USER_BRANCHES_REQUEST, getUserBranchesSaga);
}
